<script setup lang="ts">
import TelegramIcon from '~/assets/svg/telegram.svg?component'
import InstagramIcon from '~/assets/svg/instagram.svg?component'
import TwitterIcon from '~/assets/svg/twitter.svg?component'
import FacebookIcon from '~/assets/svg/facebook.svg?component'
import YouTubeIcon from '~/assets/svg/youtube.svg?component'

</script>

<template>
  <footer class="relative min-h-[420px] w-full">
   <div class="absolute bottom-0 left-0 right-0 w-full h-[420px]">
      <NuxtImg
          class="w-full h-full object-cover select-none object-bottom"
         src="/footer-arkaplan.webp"
         alt="Footer Background"
         format="webp"
         quality="75"
         style="
       -webkit-mask-image: linear-gradient(to bottom,
         rgba(0,0,0, 0) 0%,
         rgba(0,0,0, 0.8) 60%,
         rgba(0,0,0, 1) 100%
       );
       mask-image: linear-gradient(to bottom,
         rgba(0,0,0, 0) 0%,
         rgba(0,0,0, 0.8) 60%,
         rgba(0,0,0, 1) 100%
       );
     "
     />
   </div>
    
    <!-- Responsive Container -->
    <div class="relative w-full max-w-[1280px] mx-auto px-4 sm:px-6 md:px-8 pt-20 sm:pt-18 md:pt-18 pb-16 sm:pb-20 md:pb-30">
      <!-- Responsive Content Div -->
      <div class="w-full max-w-[1216px] mx-auto flex flex-col xl:flex-row items-start space-y-8 xl:space-y-0 xl:h-[252px] relative">
        <!-- Sol Sütun - Logo ve Açıklama -->
        <div class="w-full xl:w-[590px] flex flex-col justify-between space-y-6 xl:space-y-0">
          <div>
            <div class="flex items-center gap-3 mb-4">
              <NuxtImg class="w-14 h-14 object-contain"
                   src="/logo.webp"
                   alt="Hayrat Eğitim Logo"
                   format="webp"
                   quality="75"
                   :width="56"
                   :height="56"
                   placeholder="/image-placeholder.webp"
                   loading="lazy"
              />
              <h2 class="text-[#101828] text-xl sm:text-2xl font-inter font-semibold">HAYRAT EĞİTİM</h2>
            </div>

            <p class="text-[#4B5563] text-sm sm:text-base leading-6 font-inter font-normal tracking-[0%] max-w-full xl:max-w-[560px] mb-0">
              Hayrat Eğitim, Hayrât Vakfı'nın eğitim faaliyetlerini tek bir çatıda buluşturan; Kur'an-ı Kerim, Osmanlı Türkçesi ve değerler eğitimi odaklı çevrim içi ve yüz yüze programlar sunan bir öğrenme platformudur.
            </p>

            <p class="mt-4 text-sm/6 text-balance text-gray-600">
              Yardımlarınız
              <a
                href="https://hayratyardim.org/bagis"
                target="_blank"
                rel="noopener"
                class="font-semibold text-[#1168A8] hover:underline"
              >Hayrat İnsani Yardım Derneği</a>
              ile beş kıtada ihtiyaç sahiplerine ulaşıyor.
            </p>
          </div>

          <!-- Hakkımızda Link - Sadece mobil ve tablette sol sütunun altında -->
          <div class="w-full flex justify-start xl:hidden">
            <NuxtLink href="/hakkimizda" class="text-blue-600 hover:text-blue-800 transition-colors duration-200 font-inter font-medium text-sm sm:text-base">
              Hakkımızda →
            </NuxtLink>
          </div>
        </div>

        <!-- Orta Sütun - Diğer Sitelerimiz -->
        <div class="w-full xl:w-auto flex flex-col items-start xl:items-start xl:ml-[215px]">
          <h3 class="text-[#101828] text-sm font-inter font-semibold leading-5 mb-4">Diğer sitelerimiz</h3>
          <div class="flex flex-col space-y-3 items-start xl:items-start">
            <NuxtLink href="https://www.hayratvakfi.org" target="_blank" external
               class="text-gray-500 hover:text-gray-800 transition-colors duration-200 text-sm sm:text-base">Hayrat Vakfı</NuxtLink>
            <NuxtLink href="https://risale.online/" target="_blank" external
               class="text-gray-500 hover:text-gray-800 transition-colors duration-200 text-sm sm:text-base">Risale Online</NuxtLink>
            <NuxtLink href="https://osmanlica.online/" target="_blank" external
               class="text-gray-500 hover:text-gray-800 transition-colors duration-200 text-sm sm:text-base">Osmanlıca Online</NuxtLink>
            <NuxtLink href="https://kuranogren.com" target="_blank" external
               class="text-gray-500 hover:text-gray-800 transition-colors duration-200 text-sm sm:text-base">Kur'ân Öğren</NuxtLink>
          </div>
        </div>

        <!-- Sağ Sütun - Bizi Takip Edin -->
        <div class="w-full xl:w-[200px] flex flex-col items-start xl:items-start xl:ml-auto">
          <h3 class="text-[#101828] text-sm font-inter font-semibold leading-5 mb-4">Bizi takip edin</h3>
          <div class="flex gap-[24px] justify-start xl:justify-start">
            <NuxtLink href="https://t.me/hayratvakfi" target="_blank" external aria-label="Telegram'da Hayrat Vakfı"
               class="text-[#9CA3AF] transition-colors duration-200">
              <TelegramIcon class="w-6 h-6" />
            </NuxtLink>
            <NuxtLink href="https://www.instagram.com/hayratvakfi" target="_blank" external aria-label="Instagram'da Hayrat Vakfı"
               class="text-[#9CA3AF] transition-colors duration-200">
              <InstagramIcon class="w-6 h-6" />
            </NuxtLink>
            <NuxtLink href="https://x.com/hayratvakfi" target="_blank" external aria-label="X'te Hayrat Vakfı"
               class="text-[#9CA3AF] transition-colors duration-200">
              <TwitterIcon class="w-6 h-6" />
            </NuxtLink>
            <NuxtLink href="https://www.facebook.com/hayratvakfi" target="_blank" external aria-label="Facebook'ta Hayrat Vakfı"
               class="text-[#9CA3AF] transition-colors duration-200">
              <FacebookIcon class="w-6 h-6" />
            </NuxtLink>
            <NuxtLink href="https://www.youtube.com/hayratvakfi" target="_blank" external aria-label="YouTube'da Hayrat Vakfı"
               class="text-[#9CA3AF] transition-colors duration-200">
              <YouTubeIcon class="w-6 h-6" />
            </NuxtLink>
          </div>
        </div>

        <!-- Hakkımızda Link - Sadece desktop'ta ana container'ın en altından 4px yukarıda -->
        <div class="hidden xl:block xl:absolute xl:bottom-1 xl:left-0 xl:w-full xl:flex xl:justify-start">
          <NuxtLink href="/hakkimizda" class="text-blue-600 hover:text-blue-800 transition-colors duration-200 font-inter font-medium text-sm sm:text-base">
            Hakkımızda →
          </NuxtLink>
        </div>
      </div>
    </div>
  </footer>
</template>